import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePaymentEmail } from '../../actions/payment/reducePaymentEmail';
import { reduceSendPaymentLinkDto } from '../../actions/payment/reduceSendPaymentLinkDto';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPaymentEmailSaga() {
    try {
        yield put(reduceLoading({ code: 'getPaymentEmail', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/payment/contactemailaddress/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        if (result.operation.status) {
            yield put(reducePaymentEmail(result.email));
            yield put(reduceSendPaymentLinkDto(result));
        }

        yield put(reduceOperation(result.operation));
    } catch (error) {
        console.log('Error while calling Payment Email API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'getPaymentEmail', value: false }));
    }
}
